import React from 'react';
import { Link } from 'react-router-dom';

function Pagination({
  data,
  indexNumber,
  setPage,
  totalPage,
  page,
  paginationHandler,
  total,
}) {
  // Fallbacks to avoid NaN / undefined issues
  const safeTotal = Number.isFinite(total) ? total : (Array.isArray(data) ? data.length : 0);
  const pageLimit = 10; // Assuming each page has 10 items
  const startIndex = safeTotal > 0 ? (page - 1) * pageLimit + 1 : 0;
  const endIndex = safeTotal > 0 ? Math.min(page * pageLimit, safeTotal) : 0;

  return (
      data && data.length > 0 && (
          <ul className="pagination mb-0 justify-content-end items-center">
              {/* Showing the range of displayed items */}
              <p className="mr-3">
                  {/* show "items on this page of total" */}
                  {` ${data.length} of ${safeTotal}`}
              </p>

              {/* Previous Button */}
              <li className={`paginate_button page-item previous ${page === 1 ? 'disabled' : ''}`}>
                  <button
                      className={`bg-[#994263] hover:bg-[#F0D7E0] transition-colors rounded-sm ${page===1?'cursor-not-allowed opacity-50':" "}`}
                      onClick={(e) => page > 1 && paginationHandler(e, page - 1)}
                      disabled={page === 1}
                  >
                      <svg
                          stroke="currentColor"
                          fill="currentColor"
                          className="text-white"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                          <path fill="none" d="M0 0h24v24H0V0z"></path>
                          <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                      </svg>
                  </button>
              </li>

              {/* Page Info */}
              <div className="text-muted total-text d-flex align-items-center">
                  <span className="mx-1">{page}</span>
                  <span className="total-middle-text">of</span>
                  <span className="mx-1">{totalPage}</span>
              </div>

              {/* Next Button */}
              <li className={`paginate_button page-item next ${page === totalPage ? 'disabled' : ''}`}>
                  <button
                      className={`bg-[#994263] hover:bg-[#F0D7E0] transition-colors rounded-sm ${page===totalPage?'cursor-not-allowed opacity-50':" "}`}
                      onClick={(e) => page < totalPage && paginationHandler(e, page + 1)}
                      disabled={page === totalPage}
                  >
                      <svg
                          stroke="currentColor"
                          fill="currentColor"
                          className="text-white"
                          strokeWidth="0"
                          viewBox="0 0 24 24"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                          <path fill="none" d="M0 0h24v24H0V0z"></path>
                          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                      </svg>
                  </button>
              </li>
          </ul>
      )
  );
}

export default Pagination;
